var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBiconomy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 20,
    viewBox: "0 0 80 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14208_72479)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14208_72479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 4,
    width: 59,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.197 4h-58v14h58V4Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14208_72479)",
    fill: "#C4C3C2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.715 5.007c-.613 0-1.117.539-1.117 1.21 0 .67.504 1.18 1.117 1.18s1.117-.54 1.117-1.18c0-.642-.49-1.21-1.117-1.21ZM31.628 8.138h-1.812v7.169h1.812v-7.17ZM50.833 7.948c-.722 0-1.526.335-1.934 1.079v-.89H47.14v7.17h1.812v-4.124c0-.83.463-1.486 1.253-1.486.872 0 1.24.627 1.24 1.428v4.182h1.811V10.79c0-1.574-.763-2.842-2.424-2.842ZM57.462 7.92c-2.002 0-3.514 1.588-3.514 3.802 0 2.215 1.512 3.803 3.514 3.803 2.003 0 3.514-1.603 3.514-3.803S59.465 7.92 57.462 7.92Zm0 5.842c-.885 0-1.702-.7-1.702-2.04s.817-2.04 1.702-2.04c.886 0 1.703.685 1.703 2.04s-.817 2.04-1.703 2.04ZM69.368 7.934c-.885 0-1.593.32-2.125 1.194-.34-.772-1.076-1.194-1.988-1.194-.736 0-1.594.378-1.961 1.078v-.874h-1.73v7.169h1.811V11.11c0-.786.463-1.413 1.253-1.413.79 0 1.185.583 1.185 1.355v4.255h1.798v-4.196c0-.773.463-1.414 1.24-1.414.83 0 1.185.583 1.185 1.356v4.254h1.757V10.66c0-1.924-1.185-2.725-2.425-2.725v-.001ZM77.257 8.138l-1.648 4.196-1.784-4.196h-2.03l2.847 6.265-1.58 3.73h1.92l4.21-9.995h-1.935ZM35.829 13.762c-.886 0-1.703-.7-1.703-2.04s.818-2.04 1.703-2.04c.549 0 1.034.264 1.323.789l1.709-.6c-.55-1.196-1.65-1.952-3.032-1.952-2.003 0-3.514 1.589-3.514 3.803 0 2.215 1.511 3.803 3.514 3.803 1.664 0 2.92-1.107 3.297-2.745h-1.882c-.27.653-.802.982-1.415.982ZM42.94 7.92c-2.002 0-3.514 1.588-3.514 3.802 0 2.215 1.512 3.803 3.514 3.803 2.003 0 3.515-1.603 3.515-3.803S44.943 7.92 42.94 7.92Zm0 5.842c-.885 0-1.702-.7-1.702-2.04s.817-2.04 1.703-2.04c.885 0 1.702.685 1.702 2.04s-.817 2.04-1.703 2.04ZM27.426 9.028c.372-.526.45-1.032.45-1.637s-.516-2.416-2.392-2.416h-4.303V15.3h4.649c2.315 0 3.293-1.716 3.293-3.527 0-.83-.323-1.907-1.697-2.745ZM22.998 6.56h2.192c.505 0 .913.438.913.977 0 .54-.409.977-.913.977h-2.192V6.559Zm2.617 7.156h-2.617v-3.617h2.617c.934 0 1.69.81 1.69 1.808 0 1.108-.672 1.81-1.69 1.81Z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_14208_72479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.197 0h-17v20h17V0Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_14208_72479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.045 8.34c.366-.732.621-1.65.621-2.793 0-1.568-.634-2.987-1.785-3.997C11.745.554 10.208.028 8.436.028L2.331 0C1.152 0 .197.945.197 2.11V20h10.68c3.989 0 6.32-3.29 6.32-6.256 0-2.254-1.266-4.316-3.152-5.404Zm-5.61-6.77c2.867 0 4.67 1.7 4.67 3.976C13.106 8.602 10.777 10 8.42 10c-2.214 0-4.038-1.803-4.038-4.597V3.86c0-1.013-.612-1.922-1.56-2.222v-.067h5.615Z",
    fill: "#C4C3C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14208_72479"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(21.197 4)",
    d: "M0 0h58v14H0z"
  })))));
};
export default SvgBiconomy;